function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.60986 13.2891V9.21757",
  stroke: "#0A0A0A",
  strokeOpacity: 0.76,
  strokeWidth: 1.5
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.35449 14.0195L5.01602 14.0384C3.90518 14.0474 2.99988 13.1494 2.99988 12.0385V10.4685C2.99988 9.36391 3.89531 8.46848 4.99988 8.46848H7.35449",
  stroke: "#0A0A0A",
  strokeOpacity: 0.76,
  strokeWidth: 1.5
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M16.348 12.1724V8.67399C16.348 4.43577 12.9122 1 8.67399 1V1C4.43576 1 1 4.43576 1 8.67399V12.1724",
  stroke: "#0A0A0A",
  strokeOpacity: 0.76,
  strokeWidth: 1.5
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M10.7446 13.2891V9.21617",
  stroke: "#0A0A0A",
  strokeOpacity: 0.76,
  strokeWidth: 1.5
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M10 14.0195L12.3385 14.0384C13.4493 14.0474 14.3546 13.1494 14.3546 12.0385V10.4685C14.3546 9.36391 13.4592 8.46848 12.3546 8.46848H10",
  stroke: "#0A0A0A",
  strokeOpacity: 0.76,
  strokeWidth: 1.5
});

function SvgListeningExercise(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = React.forwardRef(SvgListeningExercise);
export default __webpack_public_path__ + "static/media/listening_exercise.51b177d7.svg";
export { ForwardRef as ReactComponent };